class StencilableFieldType {
  constructor(slug, name, items) {
    this.slug = slug
    this.name = name
    this.items = items
  }
}

export function findFieldTypeDescriptionByID(fieldTypeId) {
  for (let el of fieldTypes) {
    let item = el.items.find(fieldType => fieldType.id === fieldTypeId)
    if (item !== undefined) {
      return item.description || item.name || "Unknown field type"
    }
  }
}

export function findDefinitionBySlug(fieldTypeSlug) {
  for (let el of fieldTypes) {
    let item = el.items.find(fieldType => fieldType.value === fieldTypeSlug)
    if (item !== undefined) {
      return item
    }
  }
}

// Hardcoded ID based on ifttt_front_end/lib/ifttt/developers/action_field_types.rb
// You could check actions and trigger fields for a channel with:
// curl -X GET https://ifttt.com/developers/api/channels/<module_name>/configuration  --header "Authorization: Token token=<token>"
function stencilableFieldTypes() {
  return [
    new StencilableFieldType("text_field_content_type", "What kind of content is this?", [
      {
        group: "Titles",
        name: "Title of a blog post, email subject, or other short text",
        short_name: "Title",
        value: "title",
        id: 0,
      },
      {
        group: "Titles",
        name: "Title of a document",
        short_name: "Title",
        value: "collection_title",
        id: 12,
      },
      { group: "Messages", name: "HTML", value: "html", id: 6 },
      {
        group: "Messages",
        name: "Short text (140 characters or fewer)",
        short_name: "Short text",
        value: "message",
        id: 4,
      },
      {
        group: "Messages",
        name: "Long text (greater than 140 characters)",
        short_name: "Text",
        value: "body",
        id: 5,
      },
      {
        group: "Messages",
        name: "Notification (e.g., for Mobile)",
        short_name: "Notification",
        value: "mobile",
        id: 7,
      },
      { group: "Metadata", name: "File name", value: "filename", id: 2 },
      { group: "Metadata", name: "Path to a folder", value: "folder", id: 1 },
      { group: "Metadata", name: "Tags", value: "tags", id: 3 },
      { group: "URLs", name: "Link", value: "link_url", id: 8 },
      { group: "URLs", name: "Photo", value: "photo_url", id: 10 },
      { group: "URLs", name: "File", value: "file_url", id: 9 },
      { group: "URLs", name: "Audio", value: "audio_url", id: 11 },
      {
        group: "Date and Time",
        name: "ISO 8601 Date and time",
        short_name: "ISO 8601",
        value: "text_datetime",
        id: 16,
      },
      {
        group: "Other",
        name: "None of the above",
        description: "Other",
        short_name: "Text",
        value: "text_raw",
        id: 13,
      },
    ]),
    new StencilableFieldType("dropdown_field_type", "Data source for dropdown list", [
      {
        name: "Populate with list items specified here",
        value: "dropdown_static",
        id: 14,
      },
      {
        name: "Retrieve list items from my service",
        value: "dropdown_dynamic",
        id: 15,
      },
    ]),
    new StencilableFieldType("double_dropdown_field_type", "Data source for nested dropdown list", [
      {
        name: "Retrieve list items from my service",
        value: "dropdown_dynamic",
        id: 17,
      },
    ]),
    new StencilableFieldType("checkbox_field_type", "Data source for checkbox list", [
      {
        name: "Populate with checkbox items specified here",
        value: "checkbox_static",
        id: 19,
      },
      {
        name: "Retrieve checkbox items from my service",
        value: "checkbox_dynamic",
        id: 18,
      },
    ]),
  ]
}

const fieldTypes = stencilableFieldTypes()
export default fieldTypes
